import {safeSessionStorage} from './safeStorages'

const SESSION_ACTIVITY_KEY = 'teamcity.feedback.activeSeconds'

export function getActiveSeconds(): number {
  const stored = safeSessionStorage.getItem(SESSION_ACTIVITY_KEY)
  if (!stored) {
    return 0
  }
  const parsed = Number.parseInt(stored, 10)
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0
}

export function setActiveSeconds(seconds: number): void {
  safeSessionStorage.setItem(SESSION_ACTIVITY_KEY, String(seconds))
}
